import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import StaticContentForm from './forms/staticcontentForm';
import StaticContentList from './lists/staticcontentList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class staticcontentEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Statikus oldalak"}
                    footer={[
                        <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <StaticContentList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Statikus oldal"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <StaticContentForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "staticcontent", WrappedComponent: staticcontentEditor, props: {view: "admin"}});
